import getStatValue from "sgs/src/getStatValue";
import Xp from "sgs/src/Xp";

/**
 * Sorting function for arrays of objects, usually Entities.
 * @param {string} statName the property name on the object to sort by
 * @param {Boolean} reverse should the comparison be reversed
 * @param {Boolean} insensitive should the comparison be case insensitive
 */
export default function CompareStat(statName, group, reverse = false, insensitive = false){
    let sign = reverse ? -1 : 1;
    return function (a, b) {
        // console.log(a)
        a = a[group].find(x => x.name === statName);
        b = b[group].find(x => x.name === statName);
        if(!a) return 1;
        if(!b) return -1;
        a = getStatNumber(a);
        b = getStatNumber(b);
        if(a < b){
            return -1 * sign;
        }
        if(a > b){
            return 1 * sign;
        }
        return 0;
    }
}

function getStatNumber(stat){
    // console.log(stat);
    if(!stat) return Number.NEGATIVE_INFINITY;
    let number = 0;
    switch(stat.prototype.valueType) {
        case 'formula':
        case 'number':
            number = getStatValue(stat);
            break;
        case 'dieSize':
        case 'dicePool':
            number = Xp(stat);
            break;
    }
    return number;
}